import React, { useState, useEffect } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import { HiOutlineArrowDownTray } from "react-icons/hi2";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import Reveal from "../ui/Reveal";
import SectionHeading from "../ui/SectionHeading";
import pdf from "../../Assets/MUHAMMAD_ABDULLAH_SHAKOOR.pdf";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

function ResumeNew() {
  const [numPages, setNumPages] = useState(null);
  const [pageWidth, setPageWidth] = useState(680);

  useEffect(() => {
    const update = () =>
      setPageWidth(Math.max(240, Math.min(700, window.innerWidth - 88)));
    update();
    window.addEventListener("resize", update);
    return () => window.removeEventListener("resize", update);
  }, []);

  return (
    <section id="resume" className="section">
      <div className="container-page flex flex-col gap-12">
        <div className="flex flex-col gap-6 sm:flex-row sm:items-end sm:justify-between">
          <SectionHeading
            kicker="Resume"
            title="The one-page version"
            subtitle="Prefer a PDF? Grab the full document."
          />
          <Reveal>
            <a href={pdf} target="_blank" rel="noreferrer" className="btn btn-primary">
              <HiOutlineArrowDownTray /> Download CV
            </a>
          </Reveal>
        </div>

        <Reveal className="mx-auto w-full">
          <div className="card-surface mx-auto w-fit max-w-full overflow-x-auto p-4 shadow-card sm:p-6">
            <Document
              file={pdf}
              onLoadSuccess={({ numPages: n }) => setNumPages(n)}
              loading={<div className="p-16 text-sm text-ink-faint">Loading resume…</div>}
              error={
                <div className="p-16 text-sm text-ink-faint">
                  Couldn&apos;t preview the PDF —{" "}
                  <a href={pdf} className="text-accent-soft underline">
                    open it directly
                  </a>
                  .
                </div>
              }
              className="flex flex-col items-center"
            >
              {Array.from(new Array(numPages), (_, index) => (
                <Page
                  key={`page_${index + 1}`}
                  pageNumber={index + 1}
                  width={pageWidth}
                  renderTextLayer={false}
                  renderAnnotationLayer={false}
                />
              ))}
            </Document>
          </div>
        </Reveal>
      </div>
    </section>
  );
}

export default ResumeNew;
